DataGrid;

import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef, DataGridProps } from '@mui/x-data-grid';
import colors from '../../../assets/styles/colors';
import { styled } from '@mui/system';
import commons from '../../../assets/styles/commons';
import { ptBR } from '@mui/x-data-grid/locales';

interface CustomDataGridProps {
  columns: GridColDef[];
  rows: any[];
  pageSize?: number;
  rowsPerPageOptions?: number[];
  checkboxSelection?: boolean;
  disableColumnFilter?: boolean;
  selectionModel?: string[];
  disableColumnMenu?: boolean;
  disableColumnSelector?: boolean;
  onCellClick?: (rowData: any) => void;
  onSelectionModelChange?: (selectionModel: any, a: any) => void;
  getRowId?: (row: any) => string;
  rowCount?: number;
  paginationMode?: DataGridProps['paginationMode'];
  page?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiCheckbox-root': {
    color: colors.primary.orange,
    '&:focus': {
      border: `1px solid ${colors.primary.orange}`,
      color: colors.primary.orange,
    },
    '&.Mui-checked': {
      color: colors.primary.orange,
    },
  },
  '&.MuiDataGrid-root': {
    border: 'none',
  },
  '& .MuiTablePagination-root': {
    borderTop: `1px solid ${colors.primary.orange}`,
  },
  '.MuiDataGrid-columnHeaderTitle': {
    color: colors.neutral.gray,
    fontFamily: commons.fontFamily,
    alignItems: 'center',
    justifyContent: 'start',
  },
  '.MuiDataGrid-selectedRowCount': {
    color: colors.secondary.intenseNavy,
    fontFamily: commons.fontFamily,
  },
  '.MuiTablePagination-displayedRows': {
    color: colors.secondary.intenseNavy,
    fontFamily: commons.fontFamily,
  },
  '.MuiDataGrid-cell': {
    borderBottom: 'none',
    color: colors.secondary.intenseNavy,
    fontFamily: commons.fontFamily,
    alignItems: 'center',
    justifyContent: 'start',
  },
  '.MuiDataGrid-row': {
    borderBottom: 'none',
    '&.Mui-selected': {
      backgroundColor: colors.primary.paleOrange,
      '&:hover': {
        backgroundColor: colors.primary.paleOrange,
      },
    },
  },

  '.MuiDataGrid-row:hover': {
    backgroundColor: 'transparent',
  },
  '.MuiDataGrid-columnSeparator': {
    display: 'none',
  },
}));

const CustomDataGrid: React.FC<CustomDataGridProps> = ({
  columns,
  rows,
  pageSize,
  rowsPerPageOptions = [5],
  checkboxSelection = false,
  disableColumnFilter = false,
  disableColumnMenu = true,
  disableColumnSelector = false,
  selectionModel,
  onSelectionModelChange,
  onCellClick,
  getRowId,
  rowCount,
  paginationMode,
  page,
  onPageChange,
  onPageSizeChange,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <StyledDataGrid
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        rowsPerPageOptions={rowsPerPageOptions}
        checkboxSelection={checkboxSelection}
        selectionModel={selectionModel}
        disableColumnFilter={disableColumnFilter}
        disableColumnMenu={disableColumnMenu}
        disableColumnSelector={disableColumnSelector}
        autoHeight
        onSelectionModelChange={onSelectionModelChange}
        getRowId={getRowId || (row => row.id)}
        onCellClick={params => {
          if (onCellClick) {
            onCellClick(params.row);
          }
        }}
        rowCount={rowCount}
        paginationMode={paginationMode}
        page={page}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </Box>
  );
};

export default CustomDataGrid;
